/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {SearchableItem} from './interface/searchable.item';
import {SearchableSelectionType} from './interface/searchable.selection';

export class PresetValue implements SearchableItem {
  NAME: string;
  SCRIPT: string;
  VALUE: any;

  active: boolean;
  selected: boolean;
  allowed = false;

  static create(name: string, value: any, script?: string): PresetValue {
    const p = new PresetValue();
    p.NAME = name;
    p.VALUE = value;

    if (script)
      p.SCRIPT = script;

    return p;
  }

  static parseArray(json: any[]): PresetValue[] {
    const arr = [];

    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(PresetValue.create(j.NAME, j.VALUE));
        }
      }
    }

    return arr;
  }

  getName(): string {
    return this.NAME;
  }

  getFullDetails(): string {
    return this.NAME;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.SCRIPT;
  }

  getValue(): any {
    return this.VALUE;
  }

}
